import { useState } from "react";
export function MailFormat({
  initial = "Formatted",
}: {
  initial?: string | undefined;
}) {
  const [format, setFormat] = useState(initial);
  return (
    <>
      <label>
        Message format
        <select
          name="bodyFormat"
          value={format}
          onChange={(event) => setFormat(event.target.value)}
        >
          <option>Plain text</option>
          <option value="Formatted">HTML</option>
        </select>
      </label>
      {format === "Formatted" && (
        <p>
          Blank lines separate paragraphs; single line breaks stay within a paragraph.
          Use **bold**, *italic*, and start a line with - for a bullet.
        </p>
      )}
    </>
  );
}
